import React from 'react';
import LocationTemplate from './LocationTemplate';

const DudleyPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Dudley"
      stateName="North Carolina"
      countyName="Wayne"
      zipCodes={["28333"]}
      latitude={35.2810}
      longitude={-78.0169}
      population={3658}
      historicalFact="Named after Colonel Richard Dudley, a Civil War veteran who helped establish the town."
      nearbyTowns={[
        "Goldsboro, NC",
        "Mount Olive, NC",
        "Seven Springs, NC",
        "Pikeville, NC",
        "Fremont, NC",
        "La Grange, NC",
        "Kinston, NC",
        "Wilson, NC"
      ]}
    />
  );
};

export default DudleyPage;